import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  InputsDiv,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import Lock from "../../styles/images/img_lock.png";
import OnePageLayout from "../../components/layout/OnePageLayout";
import { Modal } from "../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/slices/authSlice";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";
import { getToken } from "../../components/hooks/authFunc";

const ReSettingPassword = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const accessToken = getToken();
  const email = location.state !== null ? location.state.email : "";
  const tid = location.state !== null ? location.state.tid : "";
  const [openModal, setOpenModal] = useState(false);
  const [checkedPw, setCheckedPw] = useState(false);
  const [checkedConfirmPw, setCheckedConfirmPw] = useState(false);
  const [passwords, setPasswords] = useState({
    password: "",
    confirmPassword: "",
  });
  const modalMsg = useSelector((state) => state.auth.modalMsg);
  const reSettingPasswordSuccess = useSelector(
    (state) => state.auth.reSettingPasswordSuccess
  );
  useEffect(() => {
    const passwordRegex =
      /^(?=.*[~!@#$%^&*()?])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[~!@#$%^&*()?a-zA-Z0-9]{8,20}$/;

    if (passwordRegex.test(passwords.password)) {
      setCheckedPw(true);
    } else {
      setCheckedPw(false);
    }

    if (
      passwords.password &&
      passwords.password === passwords.confirmPassword
    ) {
      setCheckedConfirmPw(true);
    } else {
      setCheckedConfirmPw(false);
    }
  }, [passwords]);

  const handleReSettingPassword = () => {
    const params = {
      email: email,
      tid: tid,
      password: passwords.password,
      confirmPassword: passwords.confirmPassword,
    };
    // console.log(params);
    dispatch(authActions.fetchReSettingPassword({ params }));
  };

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);
  const handleLogout = () => {
    // const params = {};
    // console.log("비밀번호 재설정 성공");
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    window.location.replace("/login");
  };

  return (
    <OnePageLayout title="비밀번호 재설정">
      {openModal && (
        <Modal
          setOpenModal={setOpenModal}
          title="비밀번호 재설정 완료"
          callbackFunc={
            reSettingPasswordSuccess
              ? () => handleLogout()
              : () => {
                  return;
                }
          }
        >
          <div>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</div>
        </Modal>
      )}
      <Section>
        <Content>
          <InputsDiv>
            <div>
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호를 입력하세요."
                name="password"
                value={passwords.password}
                onChange={(e) => {
                  setPasswords((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
              <SettingPwInfo>
                <p>
                  8~20자 영문 대소문자, 숫자, 특수문자 혼합,
                  <br /> 대소문자 구별 (예시 : Abc123!@#)
                  <br /> *사용가능 특수문자 : ~, !, @, #, $, %, ^, &, *, ?,
                  &#40;, &#41;
                </p>
                {!checkedPw && passwords.password != "" && (
                  <p className="pink">사용할 수 없는 비밀번호입니다.</p>
                )}
                {checkedPw && (
                  <p className="col">사용 가능한 비밀번호입니다.</p>
                )}
              </SettingPwInfo>
            </div>
            <div>
              <h3>비밀번호</h3>
              <input
                type="password"
                placeholder="비밀번호를 한번 더 입력 부탁드립니다."
                name="confirmPassword"
                value={passwords.confirmPassword}
                onChange={(e) => {
                  setPasswords((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
              <SettingPwInfo>
                {checkedConfirmPw && (
                  <p className="col">비밀번호가 일치합니다.</p>
                )}
              </SettingPwInfo>
            </div>
          </InputsDiv>
          <ImgWarp>
            <img src={Lock} alt="" />
          </ImgWarp>
        </Content>
        <Btns>
          <ButtonL
            disabled={!(checkedPw && checkedConfirmPw)}
            onClick={() => {
              handleReSettingPassword();
            }}
          >
            다음
          </ButtonL>
        </Btns>
      </Section>
    </OnePageLayout>
  );
};

export default ReSettingPassword;

const SettingPwInfo = styled(TextDiv)`
  text-align: left;
  p {
    margin-top: 1rem;
  }
`;

const ImgWarp = styled.div`
  margin-top: 5.5rem;
  text-align: center;
  img {
    width: 17.7rem;
  }
`;
